export const locale = navigator.language ?? "en-US";
